module.exports = __webpack_public_path__ + "img/signs1_3.3af0110e.jpg";